
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './Docuo-composeApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.set_$external_fun' : (_this, p0, p1, isDefault0) => _this.set(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cssText_$external_prop_setter' : (_this, v) => _this.cssText = v,
    'org.w3c.dom.css.backgroundColor_$external_prop_setter' : (_this, v) => _this.backgroundColor = v,
    'org.w3c.dom.css.border_$external_prop_setter' : (_this, v) => _this.border = v,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.visibility_$external_prop_getter' : (_this) => _this.visibility,
    'org.w3c.dom.css.visibility_$external_prop_setter' : (_this, v) => _this.visibility = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.zIndex_$external_prop_setter' : (_this, v) => _this.zIndex = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_3' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.key_$external_fun' : (_this, p0) => _this.key(p0),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.document_$external_prop_getter' : (_this) => _this.document,
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.history_$external_prop_getter' : (_this) => _this.history,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.origin_$external_prop_getter' : (_this) => _this.origin,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.hash_$external_prop_getter' : (_this) => _this.hash,
    'org.w3c.dom.reload_$external_fun' : (_this, ) => _this.reload(),
    'org.w3c.dom.go_$external_fun' : (_this, p0, isDefault0) => _this.go(isDefault0 ? undefined : p0, ),
    'org.w3c.dom.files_$external_prop_getter' : (_this) => _this.files,
    'org.w3c.dom.multiple_$external_prop_setter' : (_this, v) => _this.multiple = v,
    'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
    'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.hasAttribute_$external_fun' : (_this, p0) => _this.hasAttribute(p0),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.querySelector_$external_fun' : (_this, p0) => _this.querySelector(p0),
    'org.w3c.dom.querySelectorAll_$external_fun' : (_this, p0) => _this.querySelectorAll(p0),
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.parentNode_$external_prop_getter' : (_this) => _this.parentNode,
    'org.w3c.dom.parentElement_$external_prop_getter' : (_this) => _this.parentElement,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.offsetWidth_$external_prop_getter' : (_this) => _this.offsetWidth,
    'org.w3c.dom.offsetHeight_$external_prop_getter' : (_this) => _this.offsetHeight,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.types_$external_prop_getter' : (_this) => _this.types,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.readyState_$external_prop_getter_1' : (_this) => _this.readyState,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.OPEN_$external_prop_getter' : (_this) => _this.OPEN,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => WebSocket,
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.onchange_$external_prop_setter' : (_this, v) => _this.onchange = v,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.Companion_$external_object_getInstance_3' : () => ({}),
    'org.w3c.dom.src_$external_prop_setter' : (_this, v) => _this.src = v,
    'org.w3c.dom.allowFullscreen_$external_prop_setter' : (_this, v) => _this.allowFullscreen = v,
    'org.w3c.dom.HTMLIFrameElement_$external_class_instanceof' : (x) => x instanceof HTMLIFrameElement,
    'org.w3c.dom.HTMLIFrameElement_$external_class_get' : () => HTMLIFrameElement,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.files.name_$external_prop_getter' : (_this) => _this.name,
    'org.w3c.files.FileReader_$external_fun' : () => new FileReader(),
    'org.w3c.files.result_$external_prop_getter' : (_this) => _this.result,
    'org.w3c.files.onload_$external_prop_setter' : (_this, v) => _this.onload = v,
    'org.w3c.files.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'org.w3c.files.readAsArrayBuffer_$external_fun' : (_this, p0) => _this.readAsArrayBuffer(p0),
    'org.w3c.files.size_$external_prop_getter' : (_this) => _this.size,
    'org.w3c.files.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.sessionStorage_$external_prop_getter' : () => sessionStorage,
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'org.w3c.dom.length_$external_prop_getter_1' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.toggleVisibility' : (element, isHidden) => { 
           element.style.visibility = isHidden ? "hidden" : "visible";
         },
    'androidx.compose.ui.viewinterop.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.setClipPath' : (element, top, right, bottom, left) => { 
           element.style.setProperty("clip-path", "inset(" + top + "px " + right + "px " + bottom + "px " + left + "px)"); 
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.isWasmExportsAvailable' : () => typeof wasmExports !== 'undefined',
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.persistModule' : 
        (globalThis.module = (typeof process !== 'undefined') && (process.release.name === 'node') ?
            await import(/* webpackIgnore: true */'node:module') : void 0, () => {})
    ,
    'kotlinx.io.node.getRequire' : () => { 
        const importMeta = import.meta;
        return globalThis.module.default.createRequire(importMeta.url);
    }
    ,
    'kotlinx.io.node.requireModule' : 
        (require, mod) => {
             try {
                 let m = require(mod);
                 if (m) return m;
                 return null;
             } catch (e) {
                 return null;
             }
        }
    ,
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'com.r2sistemas.r2docuo.models.web.jsByteLength' : (src) => src.byteLength,
    'com.r2sistemas.r2docuo.models.web.jsCopyIntoLinearMemory' : (src, off, len, ptr) => {
        const s = ArrayBuffer.isView(src)
            ? new Uint8Array(src.buffer, src.byteOffset + off, len)
            : new Uint8Array(src, off, len);
        new Uint8Array(wasmExports.memory.buffer, ptr, len).set(s);
    },
    'com.r2sistemas.r2docuo.models.web.jsNewUint8Array' : (len) => new Uint8Array(len),
    'com.r2sistemas.r2docuo.models.web.jsCopyFromLinearMemory' : (ptr, len, dst, off) => { dst.set(new Uint8Array(wasmExports.memory.buffer, ptr, len), off); },
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'com.r2sistemas.r2docuo.datasource.api.upload.jsXhrUpload' : (url, headerName, headerValue, fieldName, fileName, data, timeoutMs, onProgress, onDone) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.timeout = timeoutMs;
        xhr.setRequestHeader(headerName, headerValue);
        xhr.upload.onprogress = (e) => onProgress(e.loaded, e.lengthComputable ? e.total : -1);
        xhr.onload = () => onDone(xhr.status, xhr.responseText || '', xhr.getResponseHeader('documentinfo'), null);
        xhr.onerror = () => onDone(0, '', null, 'Fail to upload');
        xhr.ontimeout = () => onDone(0, '', null, 'Upload timeout');
        xhr.onabort = () => onDone(0, '', null, 'Upload aborted');
        const form = new FormData();
        form.append(fieldName, new Blob([data]), fileName);
        xhr.send(form);
        return xhr;
    },
    'com.r2sistemas.r2docuo.datasource.api.upload.__convertKotlinClosureToJsClosure_((Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Double,Double)->Unit)'](f, p0, p1)),
    'com.r2sistemas.r2docuo.datasource.api.upload.__convertKotlinClosureToJsClosure_((Int,String,String?,String?)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3) => wasmExports['__callFunction_((Int,String,String?,String?)->Unit)'](f, p0, p1, p2, p3)),
    'com.r2sistemas.r2docuo.datasource.api.upload.jsXhrAbort' : (xhr) => xhr.abort(),
    'com.r2sistemas.r2docuo.datasource.local.file.jsRetireVisorWorker' : 
    () => {
        try {
            if (navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
                navigator.serviceWorker.getRegistrations().then((regs) => {
                    regs.forEach((reg) => { if (reg.scope.slice(-8) === '/_visor/') reg.unregister(); });
                }).catch(() => {});
            }
            if (window.caches) window.caches.delete('r2-visor').catch(() => {});
        } catch (e) {}
    }
    ,
    'com.r2sistemas.r2docuo.datasource.local.file.jsNativeFormDownload' : 
    (downloadUrl, paramsJson) => {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = 'about:blank';
        document.body.appendChild(iframe);
        const doc = iframe.contentWindow ? iframe.contentWindow.document : iframe.contentDocument;
        doc.open();
        doc.write('<html><head></head><body><form method="POST" action="' + downloadUrl + '"><input type="hidden" name="r2docuoparams" value=\'' + paramsJson + '\' /></form></body></html>');
        doc.close();
        doc.querySelector('form').submit();
        setTimeout(() => { try { document.body.removeChild(iframe); } catch(e) {} }, 30000);
    }
    ,
    'com.r2sistemas.r2docuo.datasource.local.file.jsNativeFormOpen' : 
    (openUrl, paramsJson) => {
        if (!document.body) return false;
        const name = 'r2viewer' + Date.now() + Math.random().toString(36).slice(2);
        const win = window.open('', name);
        if (!win) return false;
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = openUrl;
        form.target = name;
        form.style.display = 'none';
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'r2docuoparams';
        input.value = paramsJson;
        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
        setTimeout(() => { try { document.body.removeChild(form); } catch (e) {} }, 100);
        return true;
    }
    ,
    'com.r2sistemas.r2docuo.datasource.local.file.jsOpenPendingTab' : 
    () => {
        const win = window.open('', '_blank');
        if (!win) return null;
        try {
            const doc = win.document;
            doc.documentElement.style.colorScheme = 'light dark';
            const style = doc.createElement('style');
            style.textContent = '@keyframes r2spin{to{transform:rotate(360deg)}}'
                + 'body{margin:0;height:100vh;display:flex;align-items:center;justify-content:center}'
                + 'div{width:32px;height:32px;border:3px solid rgba(128,128,128,.25);'
                + 'border-top-color:rgba(128,128,128,.9);border-radius:50%;animation:r2spin 1s linear infinite}';
            doc.head.appendChild(style);
            doc.body.appendChild(doc.createElement('div'));
        } catch (e) {}
        return win;
    }
    ,
    'com.r2sistemas.r2docuo.datasource.local.file.downloadBlob' : 
    (data, fileName) => {
        const blob = new Blob([data], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
    ,
    'com.r2sistemas.r2docuo.datasource.local.file.jsShowInTab' : 
    (win, data, fileName, type) => {
        if (win.closed) return;
        const url = URL.createObjectURL(new File([data], fileName, { type: type }));
        win.location.replace(url);
        const watch = setInterval(() => {
            if (win.closed) { clearInterval(watch); URL.revokeObjectURL(url); }
        }, 10000);
        setTimeout(() => {
            try { if (!win.closed && win.location.href === 'about:blank') win.close(); } catch (e) {}
        }, 10000);
    }
    ,
    'com.r2sistemas.r2docuo.datasource.local.file.jsCloseTab' : (win) => { try { if (!win.closed) win.close(); } catch (e) {} },
    'com.r2sistemas.r2docuo.datasource.session.jsPageHost' : () => (typeof window !== 'undefined' && window.location) ? window.location.hostname : null,
    'com.r2sistemas.r2docuo.scriptmanager.formula.local.engine.rawEval' : (source) => (function(){try{return String(eval(source));}catch(e){return 'x';}})(),
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.material3.internal.getFirstDayOfWeek' : (locale) => { try { 
               return new Intl.Locale(locale).weekInfo.firstDay; 
            } catch (error) { 
               return -1; 
          }},
    'androidx.compose.material3.internal.getIs24HourFormat' : (localeTag) => {
                var locale = new Intl.Locale(localeTag);
                // Check for the hourCycles property first
                if (locale.hourCycles) {
                    return locale.hourCycles.includes('h23') || locale.hourCycles.includes('h24') ? 1 : 0;
                }

                // Fallback to hourCycle property
                if (locale.hourCycle) {
                    return locale.hourCycle === 'h23' || locale.hourCycle === 'h24' ? 1 : 0;
                }
                return -1;
            },
    'androidx.compose.material3.internal.emptyLocaleOptions' : () => new Object(),
    'androidx.compose.material3.internal.Date_$external_fun' : (p0) => new Date(p0),
    'androidx.compose.material3.internal.Date_$external_fun_1' : (p0, p1, p2) => new Date(p0, p1, p2),
    'androidx.compose.material3.internal.getDay_$external_fun' : (_this, ) => _this.getDay(),
    'androidx.compose.material3.internal.toLocaleDateString_$external_fun' : (_this, p0, p1, isDefault0) => _this.toLocaleDateString(p0, isDefault0 ? undefined : p1, ),
    'androidx.compose.material3.internal.now_$external_fun' : (_this, ) => _this.now(),
    'androidx.compose.material3.internal.Companion_$external_object_getInstance' : () => Date,
    'androidx.compose.material3.internal.weekday_$external_prop_setter' : (_this, v) => _this.weekday = v,
    'androidx.compose.material3.internal.year_$external_prop_setter' : (_this, v) => _this.year = v,
    'androidx.compose.material3.internal.month_$external_prop_setter' : (_this, v) => _this.month = v,
    'androidx.compose.material3.internal.day_$external_prop_setter' : (_this, v) => _this.day = v,
    'androidx.compose.material3.internal.hour_$external_prop_setter' : (_this, v) => _this.hour = v,
    'androidx.compose.material3.internal.minute_$external_prop_setter' : (_this, v) => _this.minute = v,
    'androidx.compose.material3.internal.second_$external_prop_setter' : (_this, v) => _this.second = v,
    'androidx.compose.material3.internal.Date_$external_class_instanceof' : (x) => x instanceof Date,
    'androidx.compose.material3.internal.Date_$external_class_get' : () => Date,
    'com.r2sistemas.docuoui.components.dialog.jsApplyIframeMask' : 
    (spec) => {
        var mode = spec === '*' ? 'all' : (spec.length === 0 ? 'none' : 'rects');
        var rects = [];
        if (mode === 'rects') {
            spec.split(';').forEach(function (s) {
                var p = s.split(',');
                rects.push({
                    l: parseFloat(p[0]), t: parseFloat(p[1]),
                    r: parseFloat(p[2]), b: parseFloat(p[3]),
                });
            });
        }

        // Contenedor posicionado que HtmlElementView crea alrededor del iframe:
        // aunque el iframe tenga pointer-events none, ese div sigue interceptando.
        function wrapperOf(el) {
            var p = el.parentElement;
            while (p && p !== document.body) {
                if (p.style && p.style.position === 'absolute') return p;
                p = p.parentElement;
            }
            return null;
        }
        function hide(el) {
            if (el.dataset.prevVis !== undefined) return; // ya oculto por otro overlay
            el.dataset.prevVis = el.style.visibility || '';
            el.dataset.prevPe = el.style.pointerEvents || '';
            el.style.visibility = 'hidden';
            el.style.pointerEvents = 'none';
        }
        function show(el) {
            if (el.dataset.prevVis === undefined) return;
            el.style.visibility = el.dataset.prevVis || '';
            el.style.pointerEvents = el.dataset.prevPe || '';
            delete el.dataset.prevVis;
            delete el.dataset.prevPe;
        }

        document.querySelectorAll('iframe').forEach(function (el) {
            // NATIVE_WEBVIEW_HIDER_EXEMPT_ATTRIBUTE: el iframe que es el contenido
            // de un dialogo no se toca (ni el ni su contenedor).
            if (el.hasAttribute('data-docuo-hider-exempt')) return;
            var shouldHide = false;
            if (mode === 'all') {
                shouldHide = true;
            } else if (mode === 'rects') {
                // getBoundingClientRect sigue siendo válido con visibility:hidden
                // (no saca al elemento del layout), así que re-evaluar funciona.
                var r = el.getBoundingClientRect();
                // Un iframe de area cero (R2AI colapsado a 0px junto a la ficha)
                // no tapa nada: con el redondeo podria "intersecar" y quedarse oculto.
                shouldHide = r.width > 0 && r.height > 0 && rects.some(function (o) {
                    return !(o.r <= r.left || o.l >= r.right || o.b <= r.top || o.t >= r.bottom);
                });
            }
            var w = wrapperOf(el);
            if (shouldHide) {
                hide(el);
                if (w) hide(w);
            } else {
                show(el);
                if (w) show(w);
            }
        });
    }
    ,
    'com.r2sistemas.docuoui.focus.jsInstallComposeKeyboardFocusGuard' : () => (() => {
            if (window.__r2ComposeKeyboardFocusGuard) return;
            window.__r2ComposeKeyboardFocusGuard = true;
            const isTextInput = (el) => !!el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA');
            const focusLost = () => !document.activeElement || document.activeElement === document.body;
            const composeInput = (e) => {
                const input = (e.composedPath && e.composedPath()[0]) || e.target;
                if (!isTextInput(input)) return null;
                const root = input.getRootNode ? input.getRootNode() : null;
                return (root && root.host) ? { input, root } : null;
            };
            const appCanvas = () => {
                for (const el of document.body.querySelectorAll('*')) {
                    const canvas = el.shadowRoot && el.shadowRoot.querySelector('canvas');
                    if (canvas) return canvas;
                }
                return null;
            };
            const restore = (input, root) => {
                setTimeout(() => {
                    try {
                        if (input.isConnected || !focusLost() || !document.hasFocus()) return;
                        const own = root.querySelector('canvas');
                        if (own && own.isConnected) own.focus({ preventScroll: true });
                        if (!focusLost()) return;
                        const app = appCanvas();
                        if (app && app !== own) app.focus({ preventScroll: true });
                    } catch (x) {}
                }, 0);
            };
            const observed = new WeakSet();
            document.addEventListener('focusin', (e) => {
                try {
                    const first = (e.composedPath && e.composedPath()[0]) || e.target;
                    const root = (first && first.getRootNode) ? first.getRootNode() : null;
                    if (!root || !root.host || observed.has(root) || !root.querySelector('canvas')) return;
                    observed.add(root);
                    new MutationObserver((records) => {
                        for (const record of records) {
                            for (const node of record.removedNodes) {
                                if (isTextInput(node)) restore(node, root);
                            }
                        }
                    }).observe(root, { childList: true, subtree: true });
                } catch (x) {}
            }, true);
            document.addEventListener('focusout', (e) => {
                try {
                    const found = composeInput(e);
                    if (found) restore(found.input, found.root);
                } catch (x) {}
            }, true);
        })(),
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'coil3.decode.WebWorkerRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'coil3.decode.getSkikoMemory' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'coil3.decode.id_$external_prop_getter' : (_this) => _this.id,
    'coil3.decode.kind_$external_prop_getter' : (_this) => _this.kind,
    'coil3.decode.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'coil3.decode.id_$external_prop_getter_1' : (_this) => _this.id,
    'coil3.decode.message_$external_prop_getter' : (_this) => _this.message,
    'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
    'com.r2sistemas.r2docuo.navigation.jsPushState' : (url, serial) => window.history.pushState({ r2: serial }, '', url),
    'com.r2sistemas.r2docuo.navigation.jsReplaceState' : (url, serial) => window.history.replaceState({ r2: serial }, '', url),
    'com.r2sistemas.r2docuo.navigation.jsCurrentSerial' : () => { const s = window.history.state; return (s && typeof s.r2 === 'number') ? s.r2 : 0; },
    'com.r2sistemas.r2docuo.ui.common.jsInstallHiddenIframeFocusGuard' : 
    () => {
        if (window.__hiddenIframeFocusGuard) return;
        window.__hiddenIframeFocusGuard = true;

        function deepActive() {
            var a = document.activeElement;
            while (a && a.shadowRoot && a.shadowRoot.activeElement) a = a.shadowRoot.activeElement;
            return a;
        }

        function isHiddenIframe(el) {
            if (!el || el.tagName !== 'IFRAME') return false;
            try { return getComputedStyle(el).visibility === 'hidden'; } catch (e) { return false; }
        }

        var last = null;
        var initial = deepActive();
        if (initial && initial.tagName !== 'IFRAME' && initial !== document.body) last = initial;

        // `focusin` es composed: llega al document desde dentro del shadow DOM, y
        // `composedPath()[0]` es el elemento real (el `<input>` de Compose), no el host.
        document.addEventListener('focusin', function (e) {
            var t = (e.composedPath && e.composedPath()[0]) || e.target;
            if (t && t.tagName !== 'IFRAME') last = t;
        }, true);

        window.addEventListener('blur', function () {
            // `activeElement` se actualiza tras el blur: se mira en el siguiente tick.
            setTimeout(function () {
                var a = document.activeElement;
                if (!isHiddenIframe(a)) return;
                if (!last || !last.isConnected) return;
                try {
                    last.focus({ preventScroll: true });
                    console.debug('[iframe-focus] un iframe oculto se llevo el foco; devuelto a', last.tagName);
                } catch (e) {}
            }, 0);
        });
    }
    ,
    'com.r2sistemas.r2docuo.ui.common.jsSelectPreviewTab' : 
    (iframe, fieldId, type) => {
        var w = iframe && iframe.contentWindow;
        if (!w) return;
        var direct = false;
        try { direct = typeof w.changeSelectedTab === 'function'; } catch (e) {}
        if (direct) {
            try { w.changeSelectedTab(fieldId); } catch (e) {}
            return;
        }
        try { w.postMessage({ type: type, fieldid: fieldId }, '*'); } catch (e) {}
    }
    ,
    'com.r2sistemas.r2docuo.ui.common.interaction.matchesCoarsePointer' : () => !!(typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(pointer: coarse)').matches),
    'com.r2sistemas.r2docuo.ui.documentList.components.r2ai.jsInstallR2AiCloseBridge' : 
    (iframe, onPayload) => {
        var TAG = '[r2ai-bridge]';
        var lastDeliveryAt = 0;
        var crossOriginWarned = false;

        function normalize(data) {
            try {
                return typeof data === 'string' ? data : JSON.stringify(data);
            } catch (e) {
                return '';
            }
        }

        // Deja pasar tambien Done/Sign (firmador web, `SignerWebView.wasmJs.kt`):
        // el filtro es solo un pre-corte, quien decide es el parser Kotlin de cada
        // consumidor (`parseR2AiDismiss` sigue devolviendo null para esos dos).
        function isClosePayload(s) {
            return !!s && s.indexOf('click') !== -1 &&
                   (s.indexOf('Close') !== -1 || s.indexOf('Save') !== -1 ||
                    s.indexOf('Done') !== -1 || s.indexOf('Sign') !== -1);
        }

        // Un cierre es one-shot y puede llegar por varios canales a la vez
        // (kmpJsBridge + hook de postMessage + listener). Colapsamos duplicados.
        function deliver(payload, via) {
            var s = normalize(payload);
            if (!isClosePayload(s)) return;
            var now = Date.now();
            if (now - lastDeliveryAt < 400) return;
            lastDeliveryAt = now;
            try { console.debug(TAG, 'cierre por', via, s); } catch (e) {}
            onPayload(s);
        }

        // -- Registro de R2AIs vivos ----------------------------------------
        // Puede haber dos montados a la vez (lista y ficha). El shim del host es
        // unico y no sabe quien le llama, asi que enruta al que este visible.
        var hosts = window.__r2aiBridgeHosts = window.__r2aiBridgeHosts || [];
        var entry = { iframe: iframe, deliver: deliver };
        hosts.push(entry);

        function hostDeliver(payload, via) {
            var target = null;
            for (var i = hosts.length - 1; i >= 0; i--) {
                try {
                    var f = hosts[i].iframe;
                    if (f && f.style.visibility !== 'hidden') { target = hosts[i]; break; }
                } catch (e) {}
            }
            if (!target && hosts.length) target = hosts[hosts.length - 1];
            if (target) target.deliver(payload, via + '@parent');
        }

        // -- Shim, identico en el host y dentro del iframe -------------------
        // Equivalente al initJs de compose-webview-multiplatform (movil) mas el
        // R2AI_BRIDGE_SHIM_JS de R2AIWebView.jvm.kt.
        function installShim(w, sink, hookPostMessage) {
            // 1) kmpJsBridge: contrato de Android/iOS.
            //    kmpJsBridge.callNative('message', '{"click":"Close"}', cb)
            if (!w.kmpJsBridge) {
                w.kmpJsBridge = {
                    callbacks: {},
                    callbackId: 0,
                    callNative: function (methodName, params, callback) {
                        sink(params, 'kmpJsBridge.callNative/' + methodName);
                        if (typeof callback === 'function') {
                            try { callback(''); } catch (e) {}
                        }
                    },
                    onCallback: function () {},
                    // Canal crudo del bridge: en movil el mensaje viaja envuelto
                    // en {methodName, params}.
                    postMessage: function (json) {
                        var s = normalize(json);
                        try {
                            var parsed = JSON.parse(s);
                            if (parsed && parsed.params) s = normalize(parsed.params);
                        } catch (e) {}
                        sink(s, 'kmpJsBridge.postMessage');
                    }
                };
            }

            // 2) __r2aiBridge: contrato del shim de JVM.
            if (!w.__r2aiBridge) {
                w.__r2aiBridge = {
                    onMessage: function (payload) { sink(payload, '__r2aiBridge.onMessage'); }
                };
            }

            // 3) addR2AICallbacks: la pagina lo llama al inicializarse, y lo busca
            //    en el parent. Si no existe revienta y puede quedarse sin cablear
            //    sus propios botones.
            w.__r2aiCallbacks = w.__r2aiCallbacks || {};
            if (typeof w.addR2AICallbacks !== 'function') {
                w.addR2AICallbacks = function (controlId, callbacks) {
                    if (callbacks && typeof callbacks === 'object') {
                        for (var k in callbacks) { w.__r2aiCallbacks[k] = callbacks[k]; }
                    }
                };
            }

            // 4) chrome.webview.postMessage: contrato de WebView2 (cliente WPF).
            //    El firmador web lo usa con `client=windows`. Chromium define
            //    `window.chrome` pero no `chrome.webview`: solo se stubea si falta.
            try {
                w.chrome = w.chrome || {};
                if (!w.chrome.webview) {
                    w.chrome.webview = {
                        postMessage: function (data) { sink(data, 'chrome.webview.postMessage'); },
                        addEventListener: function () {},
                        removeEventListener: function () {}
                    };
                }
            } catch (e) {}

            // 5) Hook de postMessage: solo dentro del iframe. En el host NO se
            //    toca, para no meter mano en el postMessage de toda la app.
            if (hookPostMessage) {
                try {
                    var origPostMessage = w.postMessage;
                    w.postMessage = function (data) {
                        sink(data, 'postMessage-hook');
                        return origPostMessage.apply(this, arguments);
                    };
                } catch (e) {}
            }
        }

        // -- Host: el `parent` que ve la pagina ------------------------------
        if (!window.__r2aiHostShimInstalled) {
            window.__r2aiHostShimInstalled = true;
            installShim(window, hostDeliver, false);
            try { console.debug(TAG, 'shim de host puesto en', window.location.origin); } catch (e) {}
        }

        // -- Dentro del iframe (solo same-origin) ----------------------------
        var hookedWindows = [];
        var innerHandler = function (event) { deliver(event.data, 'iframe.message'); };

        function tryInstallInner() {
            var w;
            try {
                w = iframe.contentWindow;
                if (!w) return;
                // Lanza SecurityError si el iframe es cross-origin.
                void w.location.href;
            } catch (e) {
                if (!crossOriginWarned) {
                    crossOriginWarned = true;
                    try {
                        console.warn(TAG, 'iframe CROSS-ORIGIN: la app se sirve desde ' +
                            window.location.origin + ' y R2AI desde otro origen (' + iframe.src +
                            '). Ni se puede inyectar el puente ni la pagina puede leer ' +
                            'window.parent: la X no puede funcionar hasta que los dos ' +
                            'compartan origen.');
                    } catch (e2) {}
                }
                return;
            }
            if (w.__r2aiShimInstalled) return;
            w.__r2aiShimInstalled = true;
            installShim(w, deliver, true);
            w.addEventListener('message', innerHandler);
            hookedWindows.push(w);
            try { console.debug(TAG, 'shim inyectado en el iframe:', w.location.href); } catch (e) {}
        }

        // Cada navegacion del iframe estrena `window` y se lleva el shim por
        // delante. El evento `load` llega DESPUES de que corran los scripts de la
        // pagina, asi que ademas sondeamos: si la pagina decide en su init si hay
        // bridge nativo, hay que estar puesto antes.
        iframe.addEventListener('load', tryInstallInner);
        var pollTimer = setInterval(tryInstallInner, 50);
        tryInstallInner();

        // -- Canal de reserva: la pagina postea al host ----------------------
        // Se acepta el iframe y cualquier frame anidado dentro de el; `parent` es
        // accesible incluso cross-origin, asi que la cadena se recorre siempre.
        function isFromOurIframe(source) {
            var target = iframe.contentWindow;
            if (!source || !target) return false;
            try {
                var w = source;
                for (var i = 0; i < 5 && w; i++) {
                    if (w === target) return true;
                    var p = w.parent;
                    if (!p || p === w) break;
                    w = p;
                }
            } catch (e) {}
            return false;
        }

        var hostHandler = function (event) {
            if (!isFromOurIframe(event.source)) return;
            deliver(event.data, 'host.message');
        };
        window.addEventListener('message', hostHandler);

        var cleanupId = 'r2ai_bridge_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
        window[cleanupId] = function () {
            clearInterval(pollTimer);
            window.removeEventListener('message', hostHandler);
            try { iframe.removeEventListener('load', tryInstallInner); } catch (e) {}
            for (var i = 0; i < hookedWindows.length; i++) {
                try { hookedWindows[i].removeEventListener('message', innerHandler); } catch (e) {}
            }
            hookedWindows = [];
            var at = hosts.indexOf(entry);
            if (at !== -1) hosts.splice(at, 1);
            delete window[cleanupId];
        };
        return cleanupId;
    }
    ,
    'com.r2sistemas.r2docuo.ui.documentList.components.r2ai.jsCleanupR2AiCloseBridge' : (id) => { var fn = window[id]; if (typeof fn === 'function') fn(); },
    'com.r2sistemas.r2docuo.ui.login.okta.jsOpenOktaPopup' : 
    (url, onMessage, onError) => {
        var width  = 600;
        var height = 700;
        var left   = (screen.width  - width)  / 2;
        var top    = (screen.height - height) / 2;
        var features = 'width=' + width + ',height=' + height +
                       ',left=' + left + ',top=' + top +
                       ',toolbar=no,menubar=no,scrollbars=yes,resizable=yes';

        // Limpiar canales de sesiones previas
        try { localStorage.removeItem('docuo_okta_saml'); } catch(e) {}

        var popup = window.open(url, 'OktaLogin', features);
        if (!popup) {
            onError('Popup bloqueado. Permite los popups para este sitio e inténtalo de nuevo.');
            return '';
        }

        var done = false;

        function deliver(data) {
            if (done) return;
            done = true;
            cleanup();
            try { if (popup && !popup.closed) popup.close(); } catch(e) {}
            onMessage(data);
        }

        // Canal 1: window.postMessage (opener disponible)
        var msgHandler = function(event) {
            try {
                var data = typeof event.data === 'string' ? event.data : JSON.stringify(event.data);
                if (data && data.indexOf('Saml') !== -1) deliver(data);
            } catch(e) {}
        };
        window.addEventListener('message', msgHandler);

        // Canal 2: BroadcastChannel — funciona same-origin aunque COOP corte window.opener
        var bc = null;
        try {
            bc = new BroadcastChannel('docuo_okta_saml');
            bc.onmessage = function(event) {
                var data = typeof event.data === 'string' ? event.data : JSON.stringify(event.data);
                if (data && data.indexOf('Saml') !== -1) deliver(data);
            };
        } catch(e) {}

        // Canal 3: localStorage — último recurso same-origin
        var storageHandler = function(event) {
            if (event.key === 'docuo_okta_saml' && event.newValue) {
                try { localStorage.removeItem('docuo_okta_saml'); } catch(e) {}
                if (event.newValue.indexOf('Saml') !== -1) deliver(event.newValue);
            }
        };
        window.addEventListener('storage', storageHandler);

        // Polling: detectar cierre del popup
        var pollTimer = setInterval(function() {
            if (done) { clearInterval(pollTimer); return; }
            if (popup && popup.closed) {
                clearInterval(pollTimer);
                // Dar 600ms por si llega algo por BroadcastChannel/storage justo al cerrar
                setTimeout(function() {
                    if (done) return;
                    // Comprobar localStorage como último intento
                    try {
                        var stored = localStorage.getItem('docuo_okta_saml');
                        if (stored && stored.indexOf('Saml') !== -1) {
                            localStorage.removeItem('docuo_okta_saml');
                            deliver(stored);
                            return;
                        }
                    } catch(e) {}
                    if (!done) onError('Se cerró la ventana de login sin completar la autenticación.');
                }, 600);
            }
        }, 400);

        function cleanup() {
            clearInterval(pollTimer);
            window.removeEventListener('message', msgHandler);
            window.removeEventListener('storage', storageHandler);
            try { if (bc) bc.close(); } catch(e) {}
        }

        var cleanupId = 'okta_' + Date.now();
        window[cleanupId] = function() {
            cleanup();
            try { if (popup && !popup.closed) popup.close(); } catch(e) {}
            delete window[cleanupId];
        };
        return cleanupId;
    }
    ,
    'com.r2sistemas.r2docuo.ui.login.okta.jsCleanupOktaPopup' : (id) => { var fn = window[id]; if (typeof fn === 'function') fn(); },
    'com.r2sistemas.r2docuo.utils.dnd.jsMarkDropAccepted' : (e) => { e.__docuoDropAccepted = true; },
    'com.r2sistemas.r2docuo.utils.dnd.jsIsDropAccepted' : (e) => e.__docuoDropAccepted === true,
    'com.r2sistemas.r2docuo.utils.dnd.jsHasNoRelatedTarget' : (e) => e.relatedTarget == null,
    'com.r2sistemas.r2docuo.utils.dnd.jsDroppedEntries' : 
    (dt) => {
        const out = [];
        const items = dt.items;
        if (items && items.length) {
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.kind !== 'file') continue;
                const entry = typeof item.webkitGetAsEntry === 'function' ? item.webkitGetAsEntry() : null;
                if (entry) { out.push(entry); continue; }
                const file = item.getAsFile();
                if (file) out.push({ plainFile: file });
            }
        } else if (dt.files) {
            for (let i = 0; i < dt.files.length; i++) out.push({ plainFile: dt.files[i] });
        }
        return out;
    }
    ,
    'com.r2sistemas.r2docuo.utils.dnd.jsCollectDroppedFiles' : 
    (entries, done) => {
        const out = [];
        const readAll = (dir) => new Promise((resolve) => {
            const reader = dir.createReader();
            const all = [];
            const next = () => reader.readEntries((batch) => {
                if (!batch.length) { resolve(all); return; }
                for (const e of batch) all.push(e);
                next();
            }, () => resolve(all));
            next();
        });
        const fileOf = (entry) => new Promise((resolve) => entry.file(resolve, () => resolve(null)));
        const walk = async (entry, folder, isRoot) => {
            try {
                if (entry.plainFile) { out.push({ file: entry.plainFile, folder: '' }); return; }
                if (entry.isFile) {
                    const file = await fileOf(entry);
                    if (file) out.push({ file: file, folder: folder });
                } else if (entry.isDirectory) {
                    if (!isRoot && entry.name.startsWith('.')) return;
                    const sub = folder ? folder + '/' + entry.name : entry.name;
                    const children = await readAll(entry);
                    const files = await Promise.all(children.filter((c) => c.isFile).map(fileOf));
                    for (const file of files) if (file) out.push({ file: file, folder: sub });
                    for (const child of children) if (child.isDirectory) await walk(child, sub, false);
                }
            } catch (e) { }
        };
        (async () => { for (const entry of entries) await walk(entry, '', true); })()
            .then(() => done(out), () => done(out));
    }
    ,
    'com.r2sistemas.r2docuo.utils.dnd.jsArrayLength' : (a) => a.length,
    'com.r2sistemas.r2docuo.utils.dnd.jsDroppedFileAt' : (a, i) => a[i].file,
    'com.r2sistemas.r2docuo.utils.dnd.jsDroppedFolderAt' : (a, i) => a[i].folder,
    'com.r2sistemas.r2docuo.utils.lang.overrideNavigatorLanguages' : (language) => Object.defineProperty(navigator, 'languages', { get: () => [language], configurable: true }),
    'com.r2sistemas.r2docuo.utils.lang.overrideNavigatorLanguage' : (language) => Object.defineProperty(navigator, 'language', { get: () => language, configurable: true }),
    'com.r2sistemas.r2docuo.utils.login.jsParseAdfsUid' : 
    (jsonStr) => {
        try {
            var obj = JSON.parse(jsonStr);
            return JSON.stringify({ ClientId: obj.ClientId || '', TenantId: obj.TenantId || '' });
        } catch(e) {
            return '';
        }
    }
    ,
    'com.r2sistemas.r2docuo.utils.login.jsGetJsonField' : (json, key) => { try { return JSON.parse(json)[key] || ''; } catch(e) { return ''; } },
    'com.r2sistemas.r2docuo.utils.login.jsInitMsal' : 
    (clientId, tenantId) => {
        // Sin el script de MSAL (CDN caido) el error tiene que llegar a onError.
        if (typeof msal === 'undefined') return Promise.reject('msal_not_loaded: no se cargo msal-browser');
        const config = {
            auth: {
                clientId: clientId,
                authority: 'https://login.microsoftonline.com/' + tenantId,
                redirectUri: window.location.origin
            },
            cache: {
                cacheLocation: 'sessionStorage',
                storeAuthStateInCookie: false
            }
        };
        const msalInstance = new msal.PublicClientApplication(config);
        window.__msalInstance = msalInstance;
        return msalInstance.initialize();
    }
    ,
    'com.r2sistemas.r2docuo.utils.login.jsStartAzureRedirect' : 
    (initPromise, clientId, tenantId, email, remember, onError) => {
        var KEY = 'docuo_azure_redirect';
        // Atras desde Microsoft puede devolver esta misma pagina congelada
        // (bfcache): el boton seguiria en "cargando" para siempre. MSAL limpia
        // su propio estado en ese caso; esto solo avisa a la pantalla.
        function onShow(event) {
            if (!event.persisted) return;
            window.removeEventListener('pageshow', onShow);
            try { sessionStorage.removeItem(KEY); } catch (e) {}
            onError('user_cancelled: se volvio atras sin completar el login');
        }
        Promise.resolve(initPromise)
            .then(function() {
                var msalInstance = window.__msalInstance;
                return msalInstance.handleRedirectPromise().then(function() {
                    sessionStorage.setItem(KEY, JSON.stringify({
                        clientId: clientId,
                        tenantId: tenantId,
                        email: email,
                        remember: remember,
                        returnPath: window.location.pathname + window.location.search
                    }));
                    window.addEventListener('pageshow', onShow);
                    return msalInstance.loginRedirect({ scopes: ['user.read'], loginHint: email });
                });
            })
            .catch(function(error) {
                window.removeEventListener('pageshow', onShow);
                try { sessionStorage.removeItem(KEY); } catch (e) {}
                onError(error instanceof Error ? error.message : String(error));
            });
    }
    ,
    'com.r2sistemas.r2docuo.utils.login.jsThen' : 
    (promise, onOk, onErr) => {
        Promise.resolve(promise).then(
            function(result) { onOk(result); },
            function(error)  { onErr(error instanceof Error ? error.message : String(error)); }
        );
    }
    ,
    'com.r2sistemas.r2docuo.utils.login.jsChain' : 
    (promise, nextFn) => {
        return Promise.resolve(promise).then(function() { return nextFn(); });
    }
    ,
    'com.r2sistemas.r2docuo.utils.login.__convertKotlinClosureToJsClosure_(()->Js)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Js)'](f, )),
    'com.r2sistemas.r2docuo.utils.login.jsLoginPopup' : 
    (email) => {
        const msalInstance = window.__msalInstance;
        if (!msalInstance) return Promise.reject('MSAL no inicializado');
        const loginRequest = {
            scopes: ['user.read'],
            loginHint: email
        };
        return msalInstance.loginPopup(loginRequest).then(function(response) {
            if (!response || !response.accessToken) {
                // loginPopup devuelve idToken, necesitamos accessToken via acquireTokenSilent
                const silentRequest = {
                    scopes: ['user.read'],
                    account: response.account
                };
                return msalInstance.acquireTokenSilent(silentRequest).then(function(tokenResponse) {
                    return JSON.stringify({
                        accessToken: tokenResponse.accessToken,
                        username: tokenResponse.account ? tokenResponse.account.username : ''
                    });
                });
            }
            return JSON.stringify({
                accessToken: response.accessToken,
                username: response.account ? response.account.username : ''
            });
        });
    }
    ,
    'com.r2sistemas.r2docuo.utils.login.jsAcquireTokenSilent' : 
    (email) => {
        const msalInstance = window.__msalInstance;
        if (!msalInstance) return Promise.reject('MSAL no inicializado');
        var accounts = msalInstance.getAllAccounts();
        var account = null;
        for (var i = 0; i < accounts.length; i++) {
            if (accounts[i].username.toLowerCase() === email.toLowerCase()) {
                account = accounts[i];
                break;
            }
        }
        if (!account) return Promise.reject('no_account');
        return msalInstance.acquireTokenSilent({ scopes: ['user.read'], account: account })
            .then(function(tokenResponse) {
                return JSON.stringify({
                    accessToken: tokenResponse.accessToken,
                    username: tokenResponse.account ? tokenResponse.account.username : ''
                });
            });
    }
    ,
    'com.r2sistemas.r2docuo.utils.login.jsNow' : () => Date.now(),
    'com.r2sistemas.r2docuo.utils.login.jsAwaitAzureRedirect' : 
    (onReady, onOutcome) => {
        var CONTEXT = 'docuo_azure_redirect';
        function drop() { try { sessionStorage.removeItem(CONTEXT); } catch (e) {} }
        // Una respuesta de Azure que nadie procesa no puede llegar al router (ver
        // WasmNavigationManager.migrateHashUrlIfNeeded).
        function clearAuthHash() {
            if (/(^#|&)(code|error|state)=/.test(window.location.hash)) {
                history.replaceState(history.state, '', window.location.pathname + window.location.search);
            }
        }
        var raw = null;
        try { raw = sessionStorage.getItem(CONTEXT); } catch (e) {}
        if (!raw) { clearAuthHash(); onReady(); return null; }
        var ctx = null;
        try { ctx = JSON.parse(raw); } catch (e) {}
        if (!ctx || typeof msal === 'undefined') { drop(); clearAuthHash(); onReady(); return null; }

        // La respuesta de Microsoft (llega al origen, `/#code=...`). Sin ella (se
        // abandono el login y se abrio otra URL de la app) se monta donde se esta.
        var responseHash = /(^#|&)(code|error|state)=/.test(window.location.hash) ? window.location.hash : '';
        var mounted = false;

        // La app se monta en el login del que salio, con la URL ya sin el hash:
        // asi MSAL, al limpiarlo, no apila una entrada `/#code=...` en el historial.
        function mount() {
            if (mounted) return;
            mounted = true;
            setTimeout(onReady, 0);
            try {
                if (responseHash && typeof ctx.returnPath === 'string' && /^\/(?!\/)/.test(ctx.returnPath)) {
                    history.replaceState(null, '', ctx.returnPath);
                }
            } catch (e) {}
            clearAuthHash();
        }

        function settle(outcome) {
            drop();
            onOutcome(outcome ? JSON.stringify(outcome) : null);
        }

        function fail(error) {
            mount();
            settle({ error: error instanceof Error ? error.message : String(error) });
        }

        var msalInstance;
        var initialized;
        try {
            msalInstance = new msal.PublicClientApplication({
                auth: {
                    clientId: ctx.clientId,
                    authority: 'https://login.microsoftonline.com/' + ctx.tenantId,
                    redirectUri: window.location.origin,
                    navigateToLoginRequestUrl: false
                },
                cache: { cacheLocation: 'sessionStorage', storeAuthStateInCookie: false }
            });
            window.__msalInstance = msalInstance;
            initialized = msalInstance.initialize();
        } catch (e) {
            fail(e);
            return raw;
        }
        initialized
            .then(function() {
                mount();
                return msalInstance.handleRedirectPromise(responseHash || undefined);
            })
            .then(function(response) {
                // MSAL no tenia nada que procesar (p.ej. se volvio con Atras sin
                // terminar el login): se olvida el login en curso.
                if (!response) { settle(null); return; }
                if (response.accessToken) {
                    settle({
                        accessToken: response.accessToken,
                        username: response.account ? response.account.username : ''
                    });
                    return;
                }
                return msalInstance.acquireTokenSilent({ scopes: ['user.read'], account: response.account })
                    .then(function(tokenResponse) {
                        settle({
                            accessToken: tokenResponse.accessToken,
                            username: tokenResponse.account ? tokenResponse.account.username : ''
                        });
                    });
            })
            .catch(fail);
        return raw;
    }
    ,
    'com.r2sistemas.r2docuo.utils.login.__convertKotlinClosureToJsClosure_((Js?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Unit)'](f, p0)),
    'com.r2sistemas.r2docuo.utils.captcha.jsLoadRecaptcha' : (siteKey, scriptUrl, onLoad, onError) => (() => {
            if (!document.getElementById('r2docuo-recaptcha-style')) {
                const style = document.createElement('style');
                style.id = 'r2docuo-recaptcha-style';
                style.textContent = '.grecaptcha-badge { z-index: 2147483647 !important; }';
                document.head.appendChild(style);
            }
            if (window.grecaptcha && window.grecaptcha.ready) { onLoad(); return; }
            const id = 'r2docuo-recaptcha';
            let script = document.getElementById(id);
            if (script && script.dataset.state === 'loaded') { onLoad(); return; }
            if (!script) {
                script = document.createElement('script');
                script.id = id;
                script.src = scriptUrl + '?render=' + encodeURIComponent(siteKey);
                script.async = true;
                script.dataset.state = 'loading';
                script.addEventListener('load', () => { script.dataset.state = 'loaded'; }, { once: true });
                script.addEventListener('error', () => { script.remove(); }, { once: true });
                document.head.appendChild(script);
            }
            const onLoaded = () => { script.removeEventListener('error', onFailed); onLoad(); };
            const onFailed = () => { script.removeEventListener('load', onLoaded); onError(); };
            script.addEventListener('load', onLoaded, { once: true });
            script.addEventListener('error', onFailed, { once: true });
        })(),
    'com.r2sistemas.r2docuo.utils.dnd.jsInstallStrayFileDropGuard' : () => (() => {
            if (window.__docuoStrayFileDropGuard) return;
            window.__docuoStrayFileDropGuard = true;
            const DRAG_CLASS = 'docuo-file-drag';
            const IDLE_MS = 1000;
            const root = document.documentElement;
            const style = document.createElement('style');
            style.textContent = 'html.' + DRAG_CLASS + ' iframe:not([data-docuo-file-drop-exempt]) { pointer-events: none !important; }';
            (document.head || root).appendChild(style);

            const hasFiles = (e) => {
                const types = e.dataTransfer && e.dataTransfer.types;
                if (!types) return false;
                for (let i = 0; i < types.length; i++) if (types[i] === 'Files') return true;
                return false;
            };
            let idle = 0;
            const end = () => {
                if (idle) { clearTimeout(idle); idle = 0; }
                root.classList.remove(DRAG_CLASS);
            };
            const start = () => {
                root.classList.add(DRAG_CLASS);
                if (idle) clearTimeout(idle);
                idle = setTimeout(end, IDLE_MS);
            };
            const onDragOver = (e) => {
                if (!hasFiles(e)) return;
                start();
                if (e.defaultPrevented) return;
                e.preventDefault();
                try { e.dataTransfer.dropEffect = 'none'; } catch (x) {}
            };
            const onDrop = (e) => {
                end();
                if (hasFiles(e) && !e.defaultPrevented) e.preventDefault();
            };

            const guardFrame = (frame) => {
                let w;
                try { w = frame.contentWindow; if (!w || !w.document || w.__docuoStrayFileDropGuard) return; } catch (x) { return; }
                try {
                    w.__docuoStrayFileDropGuard = true;
                    w.addEventListener('dragover', onDragOver);
                    w.addEventListener('drop', onDrop);
                    w.document.addEventListener('load', onFrameLoad, true);
                    w.document.querySelectorAll('iframe').forEach(guardFrame);
                } catch (x) {}
            };
            // `load` de un iframe no burbujea, pero pasa por la captura del documento.
            // Cada navegacion del iframe estrena ventana: se vuelve a enganchar.
            const onFrameLoad = (e) => {
                const t = e.target;
                if (t && t.tagName === 'IFRAME') guardFrame(t);
            };

            window.addEventListener('dragover', onDragOver);
            window.addEventListener('drop', onDrop);
            window.addEventListener('dragleave', (e) => {
                if (e.clientX === 0 && e.clientY === 0) { end(); return; }
                if (e.relatedTarget == null && (e.target === document || e.target === root)) end();
            });
            document.addEventListener('load', onFrameLoad, true);
            document.querySelectorAll('iframe').forEach(guardFrame);
        })(),
    'com.r2sistemas.r2docuo.utils.errors.jsListenWebGlContextLost' : (onLost) => (() => {
            const seen = new WeakSet();
            const attach = (canvas) => {
                if (seen.has(canvas)) return;
                seen.add(canvas);
                canvas.addEventListener('webglcontextlost', (e) => {
                    try {
                        let status = '';
                        try { status = String((e && e.statusMessage) || ''); } catch (x) {}
                        onLost(status);
                    } catch (x) {}
                });
            };
            const scan = (root) => {
                if (!root || typeof root.querySelectorAll !== 'function') return;
                root.querySelectorAll('canvas').forEach(attach);
                root.querySelectorAll('*').forEach((el) => { if (el.shadowRoot) scan(el.shadowRoot); });
            };
            const root = document.documentElement;
            if (!root) return;
            scan(root);
            try {
                new MutationObserver(() => scan(root)).observe(root, { childList: true, subtree: true });
            } catch (x) {}
        })(),
    'com.r2sistemas.r2docuo.utils.errors.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
    'com.r2sistemas.r2docuo.utils.errors.jsListenWindowErrors' : (onError, onRejection) => (() => {
            const str = (v) => { try { return v == null ? '' : String(v); } catch (e) { return ''; } };
            const describe = (v) => {
                const s = str(v);
                const st = (v && v.stack) ? str(v.stack) : '';
                if (!st) return s;
                return st.indexOf(s) === 0 ? st : s + '\n' + st;
            };
            window.addEventListener('error', (e) => {
                try {
                    const message = str(e && e.message) || str(e && e.type) || 'error';
                    const stack = (e && e.error) ? describe(e.error) : '';
                    onError(message, stack);
                } catch (x) {}
            });
            window.addEventListener('unhandledrejection', (e) => {
                try {
                    const reason = (e && e.reason != null) ? describe(e.reason) : '';
                    onRejection(reason || str(e && e.type) || 'unhandledrejection');
                } catch (x) {}
            });
        })(),
    'com.r2sistemas.r2docuo.utils.errors.__convertKotlinClosureToJsClosure_((String,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((String,String)->Unit)'](f, p0, p1)),
    'com.r2sistemas.r2docuo.utils.errors.jsHookConsoleError' : (onText) => (() => {
            if (typeof console === 'undefined' || typeof console.error !== 'function') return;
            if (console.error.__r2ErrorHook) return;
            const original = console.error;
            const LIMIT = 16384;
            let busy = false;
            const str = (v) => { try { return String(v); } catch (e) { return ''; } };
            const describe = (v) => {
                const s = str(v);
                const st = (v && v.stack) ? str(v.stack) : '';
                if (!st) return s;
                return st.indexOf(s) === 0 ? st : s + '\n' + st;
            };
            const hooked = function () {
                const args = Array.prototype.slice.call(arguments);
                try {
                    if (!busy) {
                        busy = true;
                        try {
                            let text = args.map(describe).join(' ');
                            if (text.length > LIMIT) text = text.slice(0, LIMIT);
                            onText(text);
                        } catch (e) {
                        } finally {
                            busy = false;
                        }
                    }
                } finally {
                    original.apply(console, args);
                }
            };
            hooked.__r2ErrorHook = true;
            console.error = hooked;
        })()
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    